export var IdPurchaseType;
(function (IdPurchaseType) {
    IdPurchaseType["premium"] = "premium";
    IdPurchaseType["standard"] = "standard";
})(IdPurchaseType || (IdPurchaseType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/ongoing-purchase/IdPurchaseType.ts
// module id = 828
// module chunks = 3